import React, { useEffect, useRef } from "react";

export default function ScreenshareContainer({
	element,
}: {
	element: HTMLVideoElement | HTMLCanvasElement | undefined;
}) {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (element) {
			containerRef.current?.appendChild(element);
		}
	}, [element]);
	return (
		<div
			ref={containerRef}
			className="screen-share-container w-full h-full flex items-center justify-center"></div>
	);
}
